import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { SwipeableDrawer, ThemeProvider, styled, useMediaQuery } from '@mui/material';

import NavbarMobileLayout2 from 'app/fuse-layouts/layout2/components/NavbarMobileLayout2';
import NavbarToggleFab from 'app/fuse-layouts/shared-components/NavbarToggleFab';
import { navbarCloseMobile } from 'app/store/fuse/navbarSlice';
import { selectNavbarTheme } from 'app/store/fuse/settingsSlice';
import NavbarLayout2 from './NavbarLayout2';

const StyledSwipeableDrawer = styled(SwipeableDrawer)(({ theme }) => ({
	'& > .MuiDrawer-paper': {
		height: '100%',
		flexDirection: 'column',
		flex: '1 1 auto',
		width: 280,
		minWidth: 280,
		transition: theme.transitions.create(['width', 'min-width'], {
			easing: theme.transitions.easing.sharp,
			duration: theme.transitions.duration.shorter
		})
	}
}));

function NavbarWrapperLayout2({ className }: { className?: string }) {
	const dispatch = useDispatch();
	const isLgUp = useMediaQuery(theme => theme.breakpoints.up('lg'));

	const config = useSelector(({ fuse }: any) => fuse.settings.current.layout.config);
	const navbarTheme = useSelector(selectNavbarTheme);
	const navbar = useSelector(({ fuse }: any) => fuse.navbar);

	return (
		<>
			<ThemeProvider theme={navbarTheme}>
				{isLgUp ? (
					<NavbarLayout2 className={className} />
				) : (
					<StyledSwipeableDrawer
						anchor="left"
						variant="temporary"
						open={navbar.mobileOpen}
						onClose={() => dispatch(navbarCloseMobile())}
						onOpen={() => {}}
						disableSwipeToOpen
						ModalProps={{
							keepMounted: true // Better open performance on mobile.
						}}
					>
						<NavbarMobileLayout2 className={className} />
					</StyledSwipeableDrawer>
				)}
			</ThemeProvider>
			{config.navbar.display && !config.toolbar.display && !isLgUp && <NavbarToggleFab />}
		</>
	);
}

export default React.memo(NavbarWrapperLayout2);
